import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material';
import { App } from './App';
import { theme } from './assets/theme';
import { AuthProvider } from './components/pages/Auth/AuthContext';
import ErrorBoundary from './components/pages/Error/ErrorBoundary';
import { initializeI18n } from './i18n';
import { Notifications } from './Notifications';
import * as serviceWorker from './serviceWorker';
import { configureStore } from './store';

import 'line-awesome/dist/line-awesome/css/line-awesome.min.css';
import '@progress/kendo-theme-material/dist/all.css';
import 'src/assets/styles/scss/fonts.scss';
import 'src/assets/styles/scss/index.scss';

const store = configureStore();

initializeI18n();

ReactDOM.render(
  <AuthProvider>
    <Notifications />
    <Provider store={store}>
      <ErrorBoundary>
        <ThemeProvider theme={theme}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </ThemeProvider>
      </ErrorBoundary>
    </Provider>
  </AuthProvider>,
  document.getElementById('lims-container')
);

serviceWorker.unregister();
